import { Component, input, computed } from '@angular/core';
import { CommunityProfile } from '../../../utils/profile.utils';
import { getStyleObjectFromUrl } from '@outlaw/core';
import { AvatarComponent } from '@outlaw/ui-kit';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.scss'],
  imports: [AvatarComponent, NgxSkeletonLoaderModule],
})
export class ProfileAvatarComponent {
  profile = input<CommunityProfile>();
  isLoading = input<boolean>(false);

  avatarUrl = computed(() => this.profile()?.avatar_url || 'assets/img/profile/avatar.webp');

  profileAvatarStyles = computed(() => {
    if (this.isLoading()) return {};

    return getStyleObjectFromUrl(this.avatarUrl());
  });
}
